module.exports = __webpack_public_path__ + "static/media/high-five.6880a709.png";